import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {useReducer} from 'react'
import _ from 'lodash'

const ActionTypes = {FAILURE, PENDING, SUCCESS, RESET: 'RESET'}
const InitialState = {
  data: [],
  errors: null,
  isLoading: false,
  page: 0,
  limit: 10,
  total: 1,
}

const Reducer = (state = InitialState, action) => {
  switch (action.type) {
    case ActionTypes.RESET:
      return _.cloneDeep(InitialState)
    case ActionTypes.PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case ActionTypes.SUCCESS:
      let _values = [...state.data, ...action.payload.data.values]

      return {
        ...state,
        isLoading: false,
        errors: null,
        data: _values,
        page: action.payload.page,
        limit: action.payload.limit,
        total: action.payload.data.values.length > 0 ? _values.length + 1 : _values.length,
      }
    case ActionTypes.FAILURE:
      return {
        ...state,
        errors: action.payload.errors,
        isLoading: false,
      }
    default:
      return state
  }
}

const useFilterFieldValuesReducer = (state = InitialState) => {
  return useReducer(Reducer, state)
}

export default useFilterFieldValuesReducer
export {ActionTypes, InitialState, Reducer}
